import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useIntl } from 'umi';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';

import type { IBaseProps } from '@/pages/intelligence/types/common';

import './index.scss';

interface ICompanyDetailsSummaryFilterProps extends IBaseProps {
  filterConfirm: (payload: any) => void;
}

const CompanyDetailsSummaryFilter: React.FC<ICompanyDetailsSummaryFilterProps> = (props) => {
  const { filterConfirm } = props;

  const { formatMessage } = useIntl();

  const defaultValue = {
    [filterKeyMap.REGION]: {
      type: 'market',
      regions: [],
      markets: ['global'],
    },
    [filterKeyMap.TIME_TYPE]: {
      value: 'month',
    },
  };

  /** 优化TODO：这一整块及inputList里的国家参数都放到model里 */
  const { regionOptions } = useMarketFilterApi({});

  const [inputList, setInputList] = useState([
    {
      key: filterKeyMap.TIME_TYPE,
      type: filterKeyMap.TIME_TYPE,
      extendFilterType: filterKeyMap.TIME_TYPE_EXTEND_TYPE.common,
      visible: 1,
      lightTheme: false,
      className: 'dbi-summary-filter-item search-item',
    },
    {
      key: filterKeyMap.REGION,
      type: filterKeyMap.REGION,
      extendFilterType: filterKeyMap.REGION_EXTEND_TYPE.common,
      visible: 1,
      options: [],
      isTopCompanies: true,
    },
  ]);

  useEffect(() => {
    if (!Array.isArray(regionOptions)) return;
    const regionIndex = inputList?.findIndex((item) => item?.key === filterKeyMap.REGION);
    if (regionIndex === -1) return;
    const inputListTmp = [...inputList];
    inputListTmp[regionIndex].options = regionOptions;
    setInputList(inputListTmp);
  }, [regionOptions]);

  // 继承逻辑在这写
  // formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  // const { filterExtend, setDetailFilterExtend, resetFilterExtend } = useFilterExtend({});
  const { setDetailFilterExtend } = useFilterExtend({});

  const formValueRef = useRef(defaultValue);

  const onConfirm = useCallback(
    (value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */) => {
      const regionType = apiValue[filterKeyMap.REGION]?.region_type;
      const regions = apiValue[filterKeyMap.REGION]?.regions;
      const formattedRegions = regionType === 'market' ? regions : regions?.map((item: string) => item?.toUpperCase());
      const filterForm = {
        region_type: regionType,
        regions: formattedRegions,
        granularity: apiValue[filterKeyMap.TIME_TYPE]?.granularity,
      };
      formValueRef.current = value;
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  return (
    <div className="dbi-summary-filter">
      <Filter showButton={false} inputList={inputList} value={formValueRef.current} onConfirm={onConfirm} />
      <div className="dbi-summary-filter-text">
        {formatMessage({ id: 'dbi_company_game_performance_summary_tips' })}
      </div>
    </div>
  );
};

export default CompanyDetailsSummaryFilter;
